// react and external-libs
import React, { useMemo } from 'react';
// MUI
import { Box, Collapse } from '@mui/material';
// interface
import { Application, Company, CompanyApplication, Version } from '../../../../../../interfaces/users.interface';
// components
import VersionDataRow from './VersionDataRow';
import { DataCell, DataRow } from '../../../../../Tables/DataList';

type VersionsAccordionProps = {
  isExpanded: boolean;
  company: Company;
  companyApp: CompanyApplication;
  application: Application;
  versions: Version[];
  canBeginNextQuestionnaire: boolean;
  onVersionRowClick: (companyApp: CompanyApplication, app: Application, version: Version, canBeginNewWorkflow?: boolean) => void;
  // Row renderer for each version. Defaults to the v1 row; the v2 sub-nav profile
  // passes VersionDataRowV2 (reads certs off the paged company-app, not the full company).
  rowComponent?: React.ComponentType<React.ComponentProps<typeof VersionDataRow>>;
};

const VersionsAccordion = (props: VersionsAccordionProps) => {
  const { isExpanded, company, companyApp, canBeginNextQuestionnaire,  application, versions, onVersionRowClick } = props;
  const RowComponent = props.rowComponent ?? VersionDataRow;
  const cellStyle = useMemo(
    () => ({ background: 'none !important', color: '#575757 !important', fontWeight: 600 }),
    [],
  );

  return (
    <Collapse in={isExpanded}>
      {/* White backdrop so the row hover highlight (#F3F5FB) reads against it; a
          no-op in the v1 accordion (already on a white card), needed in the v2 canvas. */}
      <Box sx={{ border: '1px solid #E0E2E9', backgroundColor: 'common.white' }}>
        <DataRow header sx={{ bgcolor: '#E7EAF3', marginLeft: 0, width: '100%' }}>
          <DataCell xs={1} textAlign='center' sx={cellStyle}>
            Shield
          </DataCell>
          <DataCell xs={3} textAlign='center' sx={cellStyle}>
            Version
          </DataCell>
          <DataCell xs={3} textAlign='center' sx={cellStyle}>
            Configuration Guidelines
          </DataCell>
          <DataCell xs={2} textAlign='center' sx={cellStyle}>
            Status
          </DataCell>
          <DataCell xs={2} sx={cellStyle}>
            Actions
          </DataCell>
          <DataCell xs={1} sx={cellStyle}>&nbsp;</DataCell>
        </DataRow>
        {versions.map((ver, ind) => (
          <RowComponent
            key={`${ver.id}-${ind}`}
            company={company}
            companyApp={companyApp}
            version={ver}
            application={application}
            onClick={onVersionRowClick}
            canBeginNextQuestionnaire={canBeginNextQuestionnaire}
          />
        ))}
      </Box>
    </Collapse>
  );
};

export default VersionsAccordion;
